// import "../css/modal.css";
import modalcss from "../css/modal.module.css";
import { motion } from "framer-motion";


export default function Modal({
  title,
  headerActions,
  children,
  footerActions,
  headerBottomLine = true,
  bodycss = "",
  width = "",
  height = "",
  minHeight = "",
  bodyStyle = {},
  navigateBack = "",
  class_=""
}) {
  return (
    <div
       className={`${modalcss.modal_backdrop} ${class_}`}>
      <motion.div
        initial={{ y: 500, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 0, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className={`${modalcss.modal}`}
        style={{
          ...(width ? { width: width } : {}),
          ...(height ? { height: height } : {}),
          ...(minHeight ? { minHeight: minHeight } : {}),
        }}
      >
        <div
          className={`${
            headerBottomLine
              ? modalcss.modal_header
              : modalcss.modal_header_without_bottomline
          }`}
        >

          <h2 className={modalcss.modal_title}>{navigateBack} {title}</h2>
          <div className={modalcss.modal_header_actions}>{headerActions}</div>
        </div>
        {/* {bodyStyle && (
          <div
            className={`${modalcss.modal_body}  ${bodycss}`}
            style={bodyStyle}
          >
            {children}
          </div>
        )} */}
        <div className={`${modalcss.modal_body}  ${bodycss}`} style={bodyStyle} >
          {children}
        </div>
        {footerActions && (
          <div className={modalcss.modal_footer}>{footerActions}</div>
        )}
      </motion.div>
    </div>
  );
}
